import React from 'react';

import AbsoluteTimeControl from 'src/presentation/components/pages/sidekick/threads/components/SidePanel/Components/controls/AbsoluteTimeControl';
import { Comparator } from './helpers/comparatorHelper';
import InputControl from 'src/presentation/components/pages/sidekick/threads/components/SidePanel/Components/controls/InputControl';
import RelativeTimeControl from 'src/presentation/components/pages/sidekick/threads/components/SidePanel/Components/controls/RelativeTimeControl';
import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';

const Controls = {
  [Comparator.before]: props => <RelativeTimeControl {...props} />,
  [Comparator.after]: props => <RelativeTimeControl {...props} />,
  [Comparator.on]: props => <RelativeTimeControl {...props} />,

  [Comparator.beforeAbsolute]: props => <AbsoluteTimeControl {...props} />,
  [Comparator.afterAbsolute]: props => <AbsoluteTimeControl {...props} />,
  [Comparator.onAbsolute]: props => <AbsoluteTimeControl {...props} />,
};

const TimestampControl = ({
  'data-aid': dataAid,
  attr,
  comparator,
  disabled,
  typeSpec,
}: {
  'data-aid'?: string;
  attr: string;
  comparator: Comparator;
  disabled: boolean;
  typeSpec: TypeSpec;
}) => {
  if (!comparator || !Controls[comparator]) {
    return <InputControl attr={attr} data-aid={dataAid} typeSpec={typeSpec} disabled={disabled} />;
  }

  const render = Controls[comparator]({ attr, 'data-aid': dataAid, typeSpec, comparator });

  return <>{render}</>;
};

export default TimestampControl;
